// extracted by mini-css-extract-plugin
export default {"main":"info_main__5jXLD","main__banner":"info_main__banner__XBG2Z","inner_main":"info_inner_main__8P21h"};